import { createComponent } from '@mtfe/sweet';
import { dom, common } from '@mtfe/sweet-utils';
import PoiInfoF from '../PoiInfoF/script';
import style from './style.less';
import tpl from './dom.html';

const { $id } = dom;
const { createUniqueId } = common;

let componentProps = null;
const poiInfoFlistId = createUniqueId();

const PoiInfoFList = props => {
    componentProps = props;
    
    const {
        isLazyLoadImg,
        needImpMonitor,
        poiList,
        onShopClick,
        onHasFoodRedBagClick,
        onNoFoodRedBagClick,
        btnText, 
        couponDesc, 
        isShare=true
    } = props;
 
    const events = {};

    
    const data = {
        poiInfoFlistId,
        poiList,
        renderPoiInfoF: (poiInfo, index) => {
            return PoiInfoF({
                poiInfo,
                itemIndex: index,
                needImpMonitor: needImpMonitor || false,
                isLazyLoadImg: isLazyLoadImg || false,
                btnText, 
                couponDesc, 
                isShare,
                onShopClick: () => {
                    if(onShopClick) {
                        onShopClick(poiInfo, index);
                    }
                },
                onHasFoodRedBagClick: (cb) => {
                    if(onHasFoodRedBagClick) {
                        onHasFoodRedBagClick(poiInfo, index, cb)
                    }
                },
                onNoFoodRedBagClick: (cb) => {
                    if(onNoFoodRedBagClick) {
                        onNoFoodRedBagClick(poiInfo, index, cb)
                    }
                },
            });
        }
    }

    const component = createComponent(tpl, { data, style }, events)
    return component
}

const renderPoiInfoFList = (props) => {
    const component = PoiInfoFList({ ...componentProps, ...props });
    $id(poiInfoFlistId).outerHTML = component;
}

export default PoiInfoFList;

export {
    renderPoiInfoFList
};